import * as memberService from '../services/emp_search';

export default {
  namespace: 'emp_search',

  state: {},

  effects: {
    *getStoreInfo({ payload: { values } }, { call, put }) {
      const response = yield call(memberService.getStoreInfo, values);
      yield put({
        type: 'save',
        payload: {
          stroeInfo: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
